import React, { useEffect, useState, useRef } from 'react';
import { progressStore } from './progressStore';
import './GlobalLoader.css';

const formatBytes = (bytes) => {
  if (bytes === 0) return '0 KB';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const idx = Math.min(i, 2); 
  return parseFloat((bytes / Math.pow(k, idx)).toFixed(2)) + ' ' + sizes[idx];
};

const renderSize = (loaded, total) => {
  if (total > 0) return `(${formatBytes(loaded)} / ${formatBytes(total)})`;
  if (loaded > 0) return `(${formatBytes(loaded)})`;
  return '';
};

const GlobalLoader = () => {
  const [state, setState] = useState(progressStore.getState());
  const timerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const unsub = progressStore.subscribe((s) => {
      setState(s);
      if (s.active > 0) {
        if (timerRef.current) clearTimeout(timerRef.current);
        setVisible(true);
      } else {
        timerRef.current = setTimeout(() => setVisible(false), 200);
      }
    });
    return () => { unsub(); if (timerRef.current) clearTimeout(timerRef.current); };
  }, []);

  if (!visible) return null;

  const { upload, uploadLoaded, uploadTotal, download, downloadLoaded, downloadTotal, label } = state;

  return (
    <div className="gl-overlay" aria-live="polite">
      <div className="gl-card">
        <div className="gl-title">
          <span>{label || 'Processing'} <span className="gl-dots"><span>.</span><span>.</span><span>.</span></span></span>
          <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#666' }}>Please Wait</span>
        </div>

        <div className="gl-bar-section">
          <div className="gl-bar-header">
            <span className="gl-bar-label">
              Uploading Data 
              <span style={{ fontWeight: 'normal', color: '#666', fontSize: '10.5px', marginLeft: '6px' }}>
                {renderSize(uploadLoaded, uploadTotal)}
              </span>
            </span>
            <span className="gl-bar-pct">{upload}%</span>
          </div>
          <div className="gl-track">
            <div className="gl-fill" style={{ width: `${upload}%` }} />
          </div>
        </div>

        <div className="gl-bar-section">
          <div className="gl-bar-header">
            <span className="gl-bar-label">
              Downloading Data 
              <span style={{ fontWeight: 'normal', color: '#666', fontSize: '10.5px', marginLeft: '6px' }}>
                {renderSize(downloadLoaded, downloadTotal)}
              </span>
            </span>
            <span className="gl-bar-pct">{download}%</span>
          </div>
          <div className="gl-track">
            <div className="gl-fill" style={{ width: `${download}%`, background: '#2c7a2c' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalLoader;
